<template>
  <div class="container">
    <form @submit.prevent="goNext">

      <heading-one class="-margin-md">収入証明書のご提出</heading-one>

      <errors-alert :errors="errors"></errors-alert>

      <wizard-group class="_mb-sm-35 _mb-md-50">
        <main-wizard :active-index="0" type="income"></main-wizard>
      </wizard-group>

      <slot name="message1"></slot>

      <section class="_mt-sm-20 _mt-md-30">
        <table-group>
          <table-box class="-entry _mb-md-30 _mb-sm-20">
            <table-body>
              <table-row>
                <table-header>
                  収入証明書の選択
                </table-header>
                <table-data>
                  <input-group>
                    <btngroup-radio>
                      <btn-radio v-model="certificate" id="certificate01" name="certificate" value="01">源泉徴収票</btn-radio>
                      <btn-radio v-model="certificate" id="certificate02" name="certificate" value="02">給与明細書</btn-radio>
                      <btn-radio v-model="certificate" id="certificate03" name="certificate" value="03">所得（課税）証明書</btn-radio>
                      <btn-radio v-model="certificate" id="certificate04" class="_font-sm" name="certificate" value="04">納税通知書（住民税決定通知書）</btn-radio>
                      <btn-radio v-model="certificate" id="certificate05" name="certificate" value="05">確定申告書</btn-radio>
                    </btngroup-radio>
                  </input-group>
                </table-data>
              </table-row>
            </table-body>
          </table-box>
        </table-group>

        <slot name="message2"></slot>

        <table-group>
          <table-box class="-entry">
            <table-body>
              <table-row>
                <table-header>
                  年金を受給されていますか？
                </table-header>
                <table-data>
                  <input-group>
                    <btngroup-radio>
                      <btn-radio v-model="pension" id="pension01" name="pension" value="01">受給していない</btn-radio>
                      <btn-radio v-model="pension" id="pension02" name="pension" value="02">受給している</btn-radio>
                    </btngroup-radio>
                  </input-group>
                  <div v-show="pension == '02'" class="_mt-15">
                    <input-label>以下のいずれかの書類が必要となりますので、選択してください。</input-label>
                    <input-group>
                      <btngroup-radio>
                        <btn-radio v-model="pensionDoc" id="identification01" name="identification" value="01">年金通知書</btn-radio>
                        <btn-radio v-model="pensionDoc" id="identification02" name="identification" value="02">年金証書</btn-radio>
                      </btngroup-radio>
                    </input-group>
                  </div>
                </table-data>
              </table-row>
            </table-body>
          </table-box>
        </table-group>
      </section>

      <btngroup-single class="-margin-lg">
        <btn-main class="-main" @click.prevent="goNext">
          <span class="-spnone">ファイルの選択へ</span><span class="-pcnone">撮影する</span>
        </btn-main>
      </btngroup-single>
    </form>

  </div><!-- container -->
</template>

<script>
import { INCOME_CERTIFICATE_IMAGE_AT } from '../../constants/constant'
import HeadingOne from '../../components/heading/HeadingOne'
import WizardGroup from '../../components/wizard/WizardGroup'
import MainWizard from '../../components/wizard/MainWizard'
import TableGroup from '../../components/tables/TableGroup'
import TableBox from '../../components/tables/TableBox'
import TableBody from '../../components/tables/TableBody'
import TableRow from '../../components/tables/TableRow'
import TableHeader from '../../components/tables/TableHeader'
import TableData from '../../components/tables/TableData'
import BtngroupRadio from '../../components/button/BtngroupRadio'
import BtnRadio from '../../components/button/BtnRadio'
import InputLabel from '../../components/input/InputLabel'
import BtngroupSingle from '../../components/button/BtngroupSingle'
import BtnMain from '../../components/button/BtnMain'
import ErrorsAlert from '../../components/alert/ErrorsAlert'
import InputGroup from '../../components/input/InputGroup'
import ListItem from '../list/ListItem'

export default {
  name: 'incom-top',
  components: {
    ListItem,
    InputGroup,
    ErrorsAlert,
    BtnMain,
    BtngroupSingle,
    InputLabel,
    BtnRadio,
    BtngroupRadio,
    TableData,
    TableHeader,
    TableRow,
    TableBody,
    TableBox,
    TableGroup,
    MainWizard,
    WizardGroup,
    HeadingOne
  },
  props: {
    nextPageId: ''
  },
  data () {
    return {
      errors: {},
      isDisabled: false,
      certificate: null, // 収入証明書
      pension: '01', // 年金受給
      pensionDoc: null // 年金書類
    }
  },
  mounted () {
    try {
      if (window.$cookies.get(INCOME_CERTIFICATE_IMAGE_AT)) {
        this.goToErrorPage('Image upload prohibited')
      }
    } catch (e) {
      this.goToErrorPage(e)
    }
    if (this.$route.query.certificate) {
      if (['01', '02', '03', '04', '05'].indexOf(this.$route.query.certificate) === -1) {
        this.certificate = null
      } else {
        this.certificate = this.$route.query.certificate
      }
    }
    if (this.$route.query.pension) {
      if (['01', '02'].indexOf(this.$route.query.pension) === -1) {
        this.pension = '01'
      } else {
        this.pension = this.$route.query.pension
      }
    }
    if (this.$route.query.pensionDoc) {
      if (['01', '02'].indexOf(this.$route.query.pensionDoc) === -1) {
        this.pensionDoc = null
      } else {
        this.pensionDoc = this.$route.query.pensionDoc
      }
    }
  },
  methods: {
    goNext () {
      try {
        if (this.isDisabled) {
          return
        }
        this.isDisabled = true
        this.errors = {}
        this.validateCertificate()
        this.validatePensionDoc()
        if (Object.keys(this.errors).length > 0) {
          this.isDisabled = false
          this.scrollTop()
          return
        }
        let queryParam = {
          certificate: this.certificate || '00',
          pension: this.pension || '01',
          pensionDoc: this.pension === '02' ? this.pensionDoc : '00'
        }
        this.$router.push({name: this.nextPageId, query: queryParam})
      } catch (e) {
        this.goToErrorPage(e)
      }
    },
    // 収入証明書チェック
    validateCertificate: function () {
      try {
        let reason = []
        if (this.certificate) {
          if (['01', '02', '03', '04', '05'].indexOf(this.certificate) === -1) {
            this.certificate = null
            reason.push('unselect')
          }
        } else {
          reason.push('unselect')
        }
        if (reason.length > 0) {
          if (!this.errors) this.errors = {}
          this.errors['certificate'] = reason
        }
      } catch (e) {
        this.goToErrorPage(e)
      }
    },
    // 年金書類チェック
    validatePensionDoc: function () {
      try {
        if (this.pension === '01') {
          return
        }
        let reason = []
        if (this.pensionDoc) {
          if (['01', '02'].indexOf(this.pensionDoc) === -1) {
            this.pensionDoc = null
            reason.push('unselect')
          }
        } else {
          reason.push('unselect')
        }
        if (reason.length > 0) {
          if (!this.errors) this.errors = {}
          this.errors['pensionDoc'] = reason
        }
      } catch (e) {
        this.goToErrorPage(e)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../assets/stylesheets/styles";

  .input-label {
    width: 100%;
    margin-bottom: 5px;
    color: $black !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/fileupload/IncomeTop.vue